import type { ReactNode } from "react";
import * as HoverCard from ".";

interface Props {
  id: string;
  label?: ReactNode;
  children: ReactNode;
}

// Use this component to enforce styling and add ARIA attributes
// If you want to use your own content please remember
// to provide ids for aria-labelledby and aria-describedby
export default function HoverCardContent({ id, label, children }: Props) {
  const ariaLabelledbyId = HoverCard.ariaPrefix.label + id;
  const ariaDescribedbyId = HoverCard.ariaPrefix.desc + id;

  return (
    <div className="p-4">
      {label && (
        <header className="text-charcoal-700 mb-3 text-base font-medium" id={ariaLabelledbyId}>
          {label}
        </header>
      )}
      <div className="text-charcoal-300" id={ariaDescribedbyId}>
        {children}
      </div>
    </div>
  );
}
